import {getData} from './redux_data';
import {
    GET_CENTROS_CENTRO, ADD_CENTRO_CENTRO, REMOVE_CENTRO_CENTRO,
} from '../constants/action_types';

export function getCentrosCentro(centroId) {
    return getData('GrupoCentros?centro_id=' + centroId, GET_CENTROS_CENTRO, centroId);
}

export function addCentroCentro(centro) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_CENTRO_CENTRO, payload: centro });
    }
}

export function removeCentroCentro(centro) {
    return (dispatch, getState) => {
        dispatch({ type: REMOVE_CENTRO_CENTRO, payload: centro });
    }
}